import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  permisos: [],
  totalCount: 0,
}

export const Slice = createSlice({
  name: 'permisos',
  initialState,
  reducers: {
    setPermisos: (state, action) => {
      state.permisos = action.payload
    },
    setTotalCount: (state, action) => {
      state.totalCount = action.payload
    },
  },
})

export const { setPermisos, setTotalCount } = Slice.actions
export default Slice.reducer
